import * as React from "react"
import "./styles.scss";

export default function PagePreload({selectAction}) {


    const selectpreloadDisplayAction = (action) => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("selecteddisplay", action);
            selectAction(action)
        }
    }

    return (
        <div className="page-preload-wrapper">

            <div className="background-wrapper">

                <div className="image-background-layer">
                    {/*<img src="/static/images/transparent-layer.png" alt=""/>*/}
                </div>

                <div className="logo-layer">
                    <i><img src="/static/images/logo.svg" alt=""/></i>
                </div>
            </div>


            <div className="action-wrapper">
                <button className="button-normal"
                        onClick={() => selectpreloadDisplayAction('gift')}>
                    Our gift to you
                </button>
                <button className="button-dark"
                        onClick={() => selectpreloadDisplayAction('passport')}>
                    Product journey
                </button>
            </div>


        </div>
    )
}
